import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";

import { DateFormat, Status } from "@/components/atoms";
import { SingleLineCell } from "@/components/molecules";
import { Request } from "@/shared/domain";
import { StyledTableCell, StyledTableRow } from "@/styles/styled";

import RequestModal from "../../RequestModal/RequestModal";
import { StatusColorMap } from "../../utils";
import { StyledAttachmentIcon } from "./styled";

export type RequestTableItemProps = {
    request: Request;
};

const RequestTableItem: FC<RequestTableItemProps> = ({ request }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const openDialog = () => {
        setOpen(true);
    };
    return (
        <StyledTableRow
            data-testid={`request-${request.id}`}
            hover={!!request.userRequestDocument?.length}
            onClick={() => open === false && request.userRequestDocument?.length && openDialog()}
        >
            <SingleLineCell testId="table-cell-requestActionName" highlight variant="main">
                {request.requestActionName}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-remark" highlight>
                {request.remark}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-userName" highlight>
                {request.userName}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-documentsQuantity" highlight>
                {!!request.userRequestDocument?.length && (
                    <>
                        <StyledAttachmentIcon />
                        <span className="highlightText">{`${request.userRequestDocument.length} ${t(
                            "Requests.Label.Documents",
                        )}`}</span>
                        <RequestModal request={request} open={open} setOpen={setOpen} />
                    </>
                )}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-updateDatetime" variant="grey" highlight>
                <DateFormat date={request.updateDatetime} />
            </SingleLineCell>
            <StyledTableCell data-testid="table-cell-status">
                <Status color={StatusColorMap[request.status.id]} text={request.status.name} />
            </StyledTableCell>
        </StyledTableRow>
    );
};

export default RequestTableItem;
